import React, {Component} from 'react';
import {Form} from 'antd';
import Footer from '../exercise/Footer';


const FormItem = Form.Item;


class Question extends Component {
    constructor(props) {
        super(props);
        this.state = {
          
        };
    }
  
    componentDidMount() {}

    render() {

        const {num, children} = this.props;
        let originData = this.props.data;       
		let stem = JSON.parse(originData.stem)

        
        return (
            <div className="box-exercise" ref={'viewer'}>
                <div className="exercise-content">
                    {num!=='undefined'&&<div className="exercise-num"><span className="math_text">{`${num + 1}、`}</span></div>}
                    <div className="exercise-con">
                        <span className="form-label" >中文引导语：</span>
                        <div  className="form-content">{stem.guide_text}</div>
                        <span className="form-label">引导语音频：</span>
                        <audio  className="form-content" src={stem.guide_audio} controls="controls">您的浏览器不支持</audio>
                        <span className="form-label">句子：</span>
                        <div className="form-content"> {stem.english_text} </div>
                        <span className="form-label">句子音频：</span>
                        <audio className="form-content" src={stem.english_audio} controls="controls">您的浏览器不支持</audio>
                        <span className="form-label">答题时间：</span>
                        <div className="form-content"> {stem.answer_time}s</div>
                    </div>

                </div>
                 <div className="exercise-footer">
                    <div className="footer-show relative">
                        <Footer {...this.props} obj={originData} subject={this.props.data.subject}>
                        </Footer>
                    </div>
                </div>
            </div>


        )
    }
}


export default Question;


// WEBPACK FOOTER //
// ./src/entry_question_editor/question/sentenceFollow/viewForView.js